<div class="portal-login-wrapper">
  <div class="portal-login-card">
    <div class="portal-login-header">
      <img src="../assets/images/Smee&Ford-Web-Logo-RGB-white-on-transparent.png" class="portal-logo" alt="Smee &amp; Ford" />
      <h2>Charity Central</h2>
      <p class="portal-subtitle">Client Portal</p>
    </div>

    <!-- Login view -->
    @if(view === 'login') {
      <div class="portal-login-body">
        <div class="portal-form-row">
          <label>Email</label>
          <input type="email" [(ngModel)]="email" (keyup.enter)="login()" placeholder="Enter your email" [disabled]="loading" />
        </div>
        <div class="portal-form-row">
          <label>Password</label>
          <input type="password" [(ngModel)]="password" (keyup.enter)="login()" placeholder="Enter your password" [disabled]="loading" />
        </div>
        @if(loginError) {
          <div class="portal-error">Invalid email or password. Please try again.</div>
        }
        @if(loginClientMismatch) {
          <div class="portal-error">These credentials are not valid for this portal link.</div>
        }
        <button class="portal-btn-signin" (click)="login()" [disabled]="loading">
          {{ loading ? 'Signing in...' : 'Sign In' }}
        </button>
        <div class="portal-forgot-link">
          <button type="button" class="portal-link-btn" (click)="showForgot()">Forgotten your password?</button>
        </div>
      </div>
    }

    <!-- Forgot password view -->
    @if(view === 'forgot') {
      <div class="portal-login-body">
        <p class="portal-forgot-intro">Enter your email address and we will send you a password reset link.</p>

        @if(emailTestMode) {
          <div class="portal-test-mode-container">
            <div class="portal-test-mode-badge">
              <mat-icon class="portal-test-mode-icon">warning</mat-icon>
              <span class="portal-test-mode-text">TEST MODE</span>
            </div>
            @if(testEmailSendToAddress) {
              <div class="portal-test-mode-detail">
                <mat-icon class="portal-test-mode-detail-icon">email</mat-icon>
                <span>Email will be sent to: <strong>{{ testEmailSendToAddress }}</strong></span>
              </div>
            }
          </div>
        }

        <div class="portal-form-row">
          <label>Email address</label>
          <input type="email" [(ngModel)]="forgotEmail" (keyup.enter)="submitForgotPassword()"
                 placeholder="Enter your email" [disabled]="forgotLoading" />
        </div>
        @if(forgotError) {
          <div class="portal-error">Something went wrong. Please try again.</div>
        }
        <button class="portal-btn-signin" (click)="submitForgotPassword()" [disabled]="forgotLoading || !forgotEmail.trim()">
          {{ forgotLoading ? 'Sending...' : 'Send Password Reset Email' }}
        </button>
        <div class="portal-forgot-link">
          <button type="button" class="portal-link-btn" (click)="view = 'login'">Back to sign in</button>
        </div>
      </div>
    }

    <!-- Sent confirmation view -->
    @if(view === 'sent') {
      <div class="portal-login-body">
        <div class="portal-sent-message">
          <mat-icon class="portal-sent-icon">mark_email_read</mat-icon>
          <p>You will receive a password reset email if you are a registered user. Please check your inbox.</p>
        </div>
        <div class="portal-forgot-link">
          <button type="button" class="portal-link-btn" (click)="view = 'login'">Back to sign in</button>
        </div>
      </div>
    }

  </div>
</div>
